<div class="list-welcome-item__container">
  <button mat-list-item class="list-question-item__question" [class.active]="surveyEditorService.welcomeScreenActive$()" (click)="onActivate()">
    <fa-icon [icon]="faHandWave"></fa-icon>
    Welcome screen
  </button>
  <mat-divider class="list-welcome-item__divider"></mat-divider>
</div>
